import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Instagram } from 'lucide-react';
export const HeroSection = () => {
  const instagramUrl = 'https://www.instagram.com/veranova_klussen?igsh=MTY5MmppcGx2ZmN2OQ==';
  const heroSlides = [{
    id: 1,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6hFDuMkKtrrN66CxmjRtGR/488225866_17848235589441316_3303414385176099418_n.jpg',
    title: 'Modern design, tijdloos genot',
    subtitle: 'Glazen Veranda',
    description: "Strak ontwerp en hoogwaardige materialen komen samen in onze moderne veranda's. Volledig in Nederland geproduceerd voor de hoogste kwaliteit.",
    buttonText: 'Meer informatie',
    buttonLink: '/producten#verandas'
  }, {
    id: 2,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1kkTSutEG3n1jaMh5paBAH/487922126_17848235598441316_7489604228845729630_n.jpg',
    title: 'Verleng uw leefruimte',
    subtitle: 'Maatwerk Overkapping',
    description: "Creëer een naadloze overgang tussen binnen en buiten. Onze veranda's worden perfect geïntegreerd met uw bestaande architectuur.",
    buttonText: 'Meer informatie',
    buttonLink: '/producten'
  }, {
    id: 3,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/31qoFLD89xVNfcg4Xki5Xk/491436229_17850212535441316_3063343797506131228_n.jpg',
    title: 'Geniet het hele jaar door',
    subtitle: 'Comfort & Design',
    description: 'Van zomer tot winter, transformeer uw terras in een comfortabele leefruimte. Nederlands vakmanschap met snelle levering en installatie.',
    buttonText: 'Meer informatie',
    buttonLink: '/producten'
  }, {
    id: 4,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7DEgskEqabzt1Jcwc7JHHV/madozon-zonwering_verasol-carport.jpg',
    title: 'Bescherming met stijl',
    subtitle: 'Premium Carports',
    description: 'Duurzame carports, ontworpen om uw voertuig te beschermen met stijl en efficiëntie.',
    buttonText: 'Meer informatie',
    buttonLink: '/producten#overkappingen'
  }];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const nextSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentSlide(prev => (prev + 1) % heroSlides.length);
    }
  };
  const prevSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentSlide(prev => (prev - 1 + heroSlides.length) % heroSlides.length);
    }
  };
  const goToSlide = index => {
    if (!isTransitioning && index !== currentSlide) {
      setIsTransitioning(true);
      setCurrentSlide(index);
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 700);
    return () => clearTimeout(timer);
  }, [currentSlide]);
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, [currentSlide, isTransitioning]);
  return <section className="relative w-full h-screen overflow-hidden" data-id="element-606">
      {heroSlides.map((slide, index) => <div key={slide.id} className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-607">
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/60 z-10" data-id="element-608"></div>
          <img src={slide.image} alt={`${slide.subtitle} - ${slide.title} - Veranova Klussen`} className="w-full h-full object-cover" data-id="element-609" />
          <div className="absolute inset-0 z-20 flex items-center" data-id="element-610">
            <div className="container mx-auto px-6" data-id="element-611">
              <div className="max-w-2xl mt-24 md:mt-40 mx-auto md:mx-0" data-id="element-612">
                <div className="bg-[#CDA735]/20 backdrop-blur-sm px-4 py-1 rounded-full inline-flex items-center mb-4 border border-[#CDA735]/30" data-id="element-613">
                  <span className="w-2 h-2 bg-[#CDA735] rounded-full mr-2" data-id="element-614"></span>
                  <p className="text-[#E5C872] text-sm font-medium" data-id="element-615">
                    {slide.subtitle}
                  </p>
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4" data-id="element-616">
                  {slide.title}
                </h1>
                <p className="text-white/80 text-base sm:text-lg mb-6 sm:mb-8 max-w-xl" data-id="element-617">
                  {slide.description}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-618">
                  <Link to={slide.buttonLink} className="inline-flex items-center justify-center bg-[#CDA735] hover:bg-[#B89429] text-white font-medium px-6 sm:px-8 py-3 sm:py-3.5 rounded-md shadow-lg transition-all transform hover:shadow-[0_0_20px_rgba(205,167,53,0.3)]" data-id="element-619">
                    <span data-id="element-620">{slide.buttonText}</span>
                    <svg className="ml-2 w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-621">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-622" />
                    </svg>
                  </Link>
                  <Link to="/offerte-aanvragen" className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-medium px-6 sm:px-8 py-3 sm:py-3.5 rounded-md shadow-lg transition-all" data-id="element-623">
                    <span data-id="element-624">Offerte aanvragen</span>
                  </Link>
                  <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-black/30 backdrop-blur-sm hover:bg-black/40 text-white font-medium px-4 py-3 sm:py-3.5 rounded-md transition-all sm:self-start" aria-label="Bekijk inspiratie op Instagram" data-id="element-625">
                    <Instagram size={20} className="text-[#CDA735]" data-id="element-626" />
                    <span className="ml-2 text-sm sm:text-base" data-id="element-627">
                      Inspiratie
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>)}
      {/* Navigation arrows */}
      <div className="absolute bottom-1/2 left-0 right-0 transform translate-y-1/2 z-30 container mx-auto px-6" data-id="element-628">
        <div className="flex justify-between" data-id="element-629">
          <button className="bg-black/30 backdrop-blur-sm p-2 sm:p-3 rounded-full text-white hover:bg-[#CDA735]/80 transition-colors group" onClick={prevSlide} aria-label="Vorige slide" data-id="element-630">
            <ChevronLeft size={20} className="group-hover:scale-110 transition-transform" data-id="element-631" />
          </button>
          <button className="bg-black/30 backdrop-blur-sm p-2 sm:p-3 rounded-full text-white hover:bg-[#CDA735]/80 transition-colors group" onClick={nextSlide} aria-label="Volgende slide" data-id="element-632">
            <ChevronRight size={20} className="group-hover:scale-110 transition-transform" data-id="element-633" />
          </button>
        </div>
      </div>
      {/* Slide indicators */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-30" data-id="element-634">
        <div className="bg-black/40 backdrop-blur-sm rounded-full px-4 sm:px-6 py-2 sm:py-3 flex space-x-3 sm:space-x-4" data-id="element-635">
          {heroSlides.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-2 sm:w-3 h-2 sm:h-3 rounded-full transition-all ${index === currentSlide ? 'bg-[#CDA735] scale-125' : 'bg-white/50 hover:bg-white/70'}`} aria-label={`Ga naar slide ${index + 1}`} data-id="element-636" />)}
        </div>
      </div>
      {/* Thumbnail navigation - hidden on mobile */}
      <div className="absolute bottom-0 left-0 right-0 bg-black/50 backdrop-blur-md z-30 hidden md:block" data-id="element-637">
        <div className="container mx-auto px-6 py-4" data-id="element-638">
          <div className="flex justify-center space-x-6" data-id="element-639">
            {heroSlides.map((slide, index) => <button key={slide.id} onClick={() => goToSlide(index)} className={`relative rounded-md overflow-hidden transition-all ${index === currentSlide ? 'border-2 border-[#CDA735] shadow-[0_0_15px_rgba(205,167,53,0.4)]' : 'opacity-70 hover:opacity-100 border border-white/20'}`} style={{
            width: '160px',
            height: '80px'
          }} data-id="element-640">
                <img src={slide.image} alt={`Thumbnail voor ${slide.title}`} className="w-full h-full object-cover" data-id="element-641" />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center" data-id="element-642">
                  <span className="text-white text-xs font-medium" data-id="element-643">
                    {slide.subtitle}
                  </span>
                </div>
              </button>)}
          </div>
        </div>
      </div>
      {/* CSS Variable for header height */}
      <style jsx data-id="element-644">{`
        :root {
          --header-height: 0px;
        }
      `}</style>
    </section>;
};